import { render, staticRenderFns } from "./literatureList.vue?vue&type=template&id=a57502c8&scoped=true&"
import script from "./literatureList.vue?vue&type=script&lang=js&"
export * from "./literatureList.vue?vue&type=script&lang=js&"
import style0 from "./literatureList.vue?vue&type=style&index=0&id=a57502c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57502c8",
  null
  
)

export default component.exports